export const ListMyPlan = {
    CREATE_PLAN_SUCCESS: 'CREATE_PLAN_SUCCESS',
    CREATE_PLAN_FAILED: 'CREATE_PLAN_FAILED',
}